import { DeviceReading, ReadingStatus, ResourceSourceType } from '@types';
import { isEmpty } from 'lodash';

const resourceSourceTypeDescriptions = {
	[ResourceSourceType.DEPT]: 'Department',
	[ResourceSourceType.APP]: 'WaterIQ App',
	[ResourceSourceType.WEB]: 'WaterIQ Customer Portal',
	[ResourceSourceType.APP_2]: 'WaterIQ App',
	[ResourceSourceType.WEB_2]: 'WaterIQ Customer Portal',
};

/**
 * Returns the reading value from a DeviceReading object. If `rawDialsReading` is not available, it
 * falls back to `rawVariableReading`.
 * @param deviceReading - The DeviceReading object containing reading data.
 * @returns The reading value as a string, either from `rawDialsReading` or `rawVariableReading`.
 */
export const displayReadingValue = (deviceReading?: DeviceReading) => {
	return deviceReading?.rawDialsReading ?? deviceReading?.rawVariableReading;
};

export const displayResourceSourceType = (resourceType?: ResourceSourceType) => {
	if (!resourceType) {
		return '-';
	}
	return resourceSourceTypeDescriptions[resourceType] ?? resourceType;
};

export const displayVolumeOrStatus = (
	take: number | undefined,
	readingStatus: string | undefined,
	usageUnit: string,
) => {
	if (
		(readingStatus === ReadingStatus.SUBMITTED || readingStatus === ReadingStatus.VERIFIED) &&
		take !== undefined
	) {
		return take.toFixed(3).concat(' ', usageUnit);
	} else if (
		readingStatus == ReadingStatus.REQUIRES_REVIEW ||
		readingStatus == ReadingStatus.WITHDRAWN
	) {
		return readingStatus;
	} else {
		return 'Pending';
	}
};

export const hasAssessedTake = (meterReading: DeviceReading) => {
	return (
		!isEmpty(meterReading.status) &&
		[ReadingStatus.VERIFIED, ReadingStatus.REQUIRES_REVIEW, ReadingStatus.SUBMITTED].includes(
			meterReading.status as ReadingStatus,
		) &&
		(meterReading?.assessedTake ?? 0) > 0 // Only APPROVED assessed takes are returned by API
	);
};
